import React from 'react';
import PropTypes from 'prop-types';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';

import { IconButton } from '@mui/material';
import Container from './styles/Container';
import ExportDataBySensors from '../../../features/export/ExportDataBySensors/ExportDataBySensors';

function VehicleHistoryToolbarWidget({
  isSearchGeozoneActive,
  onClickSearchGeozone,
  onClickExportData,
  vehicleId,
  dateFrom,
  dateTo,
}) {
  return (
    <Container>
      <IconButton
        title="Поиск геозоны"
        onClick={onClickSearchGeozone}
        color={isSearchGeozoneActive ? 'primary' : 'default'}
      >
        <TravelExploreIcon />
      </IconButton>
      {!!onClickExportData && (
        <IconButton title="Экспорт треков" onClick={onClickExportData}>
          <FileDownloadIcon />
        </IconButton>
      )}
      {!!vehicleId && <ExportDataBySensors vehicleId={vehicleId} dateFrom={dateFrom} dateTo={dateTo} />}
    </Container>
  );
}

VehicleHistoryToolbarWidget.propTypes = {
  vehicleId: PropTypes.number,
  isSearchGeozoneActive: PropTypes.bool.isRequired,
  onClickSearchGeozone: PropTypes.func.isRequired,
  onClickExportData: PropTypes.func,
  dateFrom: PropTypes.instanceOf(Date),
  dateTo: PropTypes.instanceOf(Date),
};

VehicleHistoryToolbarWidget.defaultProps = {
  onClickExportData: null,
  vehicleId: null,
  dateFrom: null,
  dateTo: null,
};

export default VehicleHistoryToolbarWidget;
